module.exports = __webpack_public_path__ + "img/daniil_80x80.98171bcc.png";